import { useState } from 'react';
import api from './MeshApi';

const RotateKeystone = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [saveErrorMessage, setSaveErrorMessage] = useState('');

  const handleRotateKeystone = async () => {
    try {
      setIsSaving(true);
      setSaveErrorMessage('');
      await api.rotateKeystone();
    } catch (error) {
      console.error('Failed to rotate keystone:', error);
      setSaveErrorMessage('Failed to rotate keystone. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="configuration-container">
      <div className="form-group">
        Confirm keystone rotation
        <button
          className="btn submit-btn"
          onClick={handleRotateKeystone}
          disabled={isSaving}
        >
          {isSaving ? 'Submitting...' : 'Submit'}
        </button>
        {saveErrorMessage && <div className="alert error-message">{saveErrorMessage}</div>}
      </div>
    </div>
  );
};

export default RotateKeystone;
